import React, {useState} from 'react';
import * as _ from 'lodash';
import * as moment from "moment";
import {useDispatch, useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import * as styles from './style.css';
import StickersComponentsMediaPhoto from "../../components/media-photo";
import {getDisplayedUser} from "../../../domain/services/StickerHelpers";
import StickersComponentsMediaAudio from "../../components/media-audio";
import StickersComponentsMediaVideo from "../../components/media-video";
import StickersComponentsStickerComments from "../../components/sticker-comments";
// import StickersComponentsStickerControls from "../../components/bubble-container";
import Icon from "../../../../icons/Icon";
import {StickerFormatEnum} from "../../../domain/enums/StickerFormatEnum";
import {
    authUserStateSelector, currentUserInfoSelector,
} from "../../../../auth/store/auth-user/selectors";
import Div100vh from "../../../../uq-ui/components/div-100";
import LayoutComponentsLoaderProcessing from "../../../../layout/ui/components/loader-processing";
import {Fragment} from "react";
import { stickerShowStateSelector, isMemorialType } from "../../../store/sticker-show/selectors";
import {getTextDirection} from "../../../../uq-ui/helpers/messageDirection";
// import i18n from '../../../../../i18n';
import TextWithLinks from '../../../../uq-ui/components/text-with-links';
import ThemesScrollbar from "../../../../layout/ui/components/themed-scrollbar";
import linearTranslation from "../../../../../utils/linear-translation";
import {useHistory, useParams} from "react-router";
import {themesSelector} from "../../../store/dictionaries/selectors";
import {deleteStickerItem} from "../../../store/entities/sticker-items/actions";
import ConfirmModal from "../../../../uq-ui/components/confirm-modal";
import UQButton from "../../../../uq-ui/components/button";
import BubbleContainer from "../../components/bubble-container";
import {useStickerItem} from "../../../store/sticker-show/hooks";


export default function StickerItemScreensShow(props) {
    const {id: stickerId, itemId: stickerItemId} = useParams()
    const currentUser = useSelector(currentUserInfoSelector);
    const {t} = useTranslation("scr-show-sticker-item")
    const authState = useSelector(authUserStateSelector);
    const showState = useSelector(stickerShowStateSelector);
    const themes = useSelector(themesSelector);
    const [stickerItem, stickerItemStatus] = useStickerItem(stickerId, stickerItemId)
    const history = useHistory();
    const dispatch: (any) => Promise<any> = useDispatch();
    const [confirmStickerDelete, setConfirmStickerDelete] = useState<boolean>(false);
    const isMySticker = currentUser.id === stickerItem?.from?.id
    const isStickerTypeMemorial = stickerItem?.type === 'MEMORIAL' ?? useSelector(isMemorialType);
    isStickerTypeMemorial && props.appThemeChanger('setMemorialTheme');

    if (stickerItemStatus === 'failed'){
        history.push(`/stickers/${stickerId}`);
    }

    const onBack = () => {
        history.push(`/stickers/${stickerId}`);
    }

    const renderDate = () => {
        const dateString = getDateString();
        if (dateString) {
            return (<div className={ isStickerTypeMemorial ? styles.dateString_memorial : styles.dateString }>{dateString}</div>);
        }
        return null;
    }

    const renderAuthor = () => {
        return (<div className={styles.author}>{getAuthorString()}</div>)
    }

    const getAuthorString = () => {
        const displayedUser = getDisplayedUser(stickerItem);
        return displayedUser.display_name;
    }

    const getDateString = () => {
        if (!stickerItem) {
            return
        }

        const date = stickerItem.configured_date;
        if (date) {
            return moment(date).format('MMM YYYY');
        }
        return null;
    }

    const renderGreeting = () => {
        if (!stickerItem) {
            return
        }

        const value = linearTranslation(window.innerHeight, 550, 80, 750, 160);
        let maxHeight = `${value}px`;
        const {greeting_text} = stickerItem;
        const hasLinks = greeting_text.search(/https/ig) === -1;
        const direction = getTextDirection(greeting_text);
        // @ts-ignore
        return (<ThemesScrollbar maxHeight={maxHeight} direction={direction}>
                {hasLinks ?
                    greeting_text
                    :
                    <TextWithLinks linkStyle={{color: '#495BFF', textDecorationLine: 'underline', cursor: 'default'}}
                                   text={greeting_text}/>
                }
            </ThemesScrollbar>
        );
    }

    const renderTextContent = () => {
        if (!stickerItem) {
            return
        }

        const {greeting_text, views_count} = stickerItem;
        const hasText = greeting_text != null && greeting_text !== '';
        const direction = getTextDirection(greeting_text || '');
        // const appDirection = i18n.dir();

        if (hasText) {
            return (
                <Fragment>
                    <div style={{position: "relative"}}>
                        <div className={ isStickerTypeMemorial ? styles.stickerText_memorial : styles.stickerText } style={{direction: direction}}>
                            {renderGreeting()}
                        </div>
                    </div>
                    <div className={styles.authorDateContainer}>
                        <div className={ isStickerTypeMemorial ? styles.authorDateInner_memorial : styles.authorDateInner }>
                            {getAuthorString() && renderAuthor()}
                            {renderDate()}
                        </div>
                        {/*<div style={{direction: appDirection}} className={styles.scansCounterContainer}>*/}
                        {/*    <Icon name="CounterEye" width="16px" height="9px" className={styles.scansCounterIcon}/>*/}
                        {/*    <div*/}
                        {/*        className={styles.scansCounterText}>{` ${views_count || '0'} ${t('views')}`}</div>*/}
                        {/*</div>*/}
                    </div>
                </Fragment>
            )
        }

        const dateAuthor = getAuthorString() ? `${getAuthorString()}, ${getDateString()}` : `${getDateString()}`;
        return (
            <div className={styles.dateAndCountContainer} style={{direction: direction}}>
                <div className={styles.scansCounterContainer}>
                    <Icon name="CounterEye" width="16px" height="9px" className={styles.scansCounterIcon}/>
                    <div className={styles.scansCounterText}>{` ${views_count || '0'} ${t('views')}`}</div>
                </div>
                <div className={ isStickerTypeMemorial ? styles.dateString_memorial : styles.dateString }>{dateAuthor}</div>
            </div>
        );
    }

    // @ts-ignore
    const renderTheme = () => {
        if (!isGreetingType() || !stickerItem) {
            return <div/>
        }

        const themeId = stickerItem.template;
        const theme = themes.find((tpl) => Number(tpl.id) === Number(themeId));

        if (theme) {
            return (
                <img src={theme.show.source.srcSvg} className={styles.theme}/>
            )
        }
        return null;
    }

    const renderStickerMedia = () => {
        if (!stickerItem) {
            return
        }

        switch (stickerItem.format) {
            case StickerFormatEnum.Image:
                const imageSource = _.get(stickerItem, 'photo.original.source');
                return (<StickersComponentsMediaPhoto source={imageSource} isMemorial={ isStickerTypeMemorial } />);
            case StickerFormatEnum.Audio:
                const audioSource = _.get(stickerItem, 'audio.original.source');
                const audioDuration = _.get(stickerItem, 'audio.duration');
                if (audioDuration != null && audioSource != null) {
                    return (
                        <StickersComponentsMediaAudio
                            source={audioSource}
                            duration={audioDuration}/>
                    );
                }
                return null;
            case StickerFormatEnum.Video:
                const videoSource = _.get(stickerItem, 'video.original.source');
                const videoDuration = _.get(stickerItem, 'video.duration');
                const videoThumbnail = _.get(stickerItem, 'video.thumbnail.source');
                return (<StickersComponentsMediaVideo
                    duration={videoDuration}
                    thumbnail={videoThumbnail}
                    source={videoSource}/>);
            default:
                return null;
        }
    }

    const isGreetingType = () => {
        return _.get(stickerItem, 'type') === "GREETING";
    };

    const renderComments = () => {
        if (!isGreetingType()) {
            return <div/>
        }

        return <StickersComponentsStickerComments
            unreadCount={showState.unreadCommentsCount}
            comments={showState.comments}
            containerStyle={{marginTop: '-44px'}}/>
    };

    const renderControls = () => {
        if (!isMySticker || !isStickerTypeMemorial) {
            return <></>
        }

        return <BubbleContainer
            title={t('controlsTitle')}
            innerStyle={{alignItems: "flex-start"}}
            theme={ isStickerTypeMemorial ? 'memorial' : 'base' }
        >
            <div className={'font-text'} style={{
                width: "100%",
                color: "#252D76",
                borderBottom: "1px solid rgba(37, 45, 118, 0.1)",
                marginBottom: "15px"
            }}>
                {t('controlsAdvancedPermissions')}
            </div>
            <UQButton label={t('deleteButton')}
                      theme={'danger'}
                      containerClass={styles.attachFloatButton}
                      onPress={() => {
                          setConfirmStickerDelete(true)
                      }}/>
        </BubbleContainer>
    };

    const renderStickerShow = () => {
        return (
            <Fragment>
                <div className={styles.sticker}>
                    <Div100vh style={{minHeight: '100rvh', position: 'relative'}} withResize={false}>
                        <div className={styles.stickerTop}>
                            <button type="button"
                                    onClick={onBack}
                                    className={ isStickerTypeMemorial ? styles.backButton_memorial : styles.backButton }>
                                <Icon name={ isStickerTypeMemorial ? 'HeaderBackDarkBlue' : 'HeaderBackDark' } style={{width: "20px"}}/>
                            </button>
                            <div className={styles.stickerMediaContainer}>
                                {authState.isSessionLoaded && renderStickerMedia()}
                            </div>
                            {renderTextContent()}
                        </div>
                        {renderTheme()}
                    </Div100vh>
                    {renderComments()}
                    {renderControls()}
                </div>
            </Fragment>
        )
    }

    return <Fragment>
        <ConfirmModal
            show={confirmStickerDelete}
            title={t('deleteTitle')}
            styles={{zIndex: 105}}
            showConfirmBtn={false}
            onClose={() => setConfirmStickerDelete(false)}
            isMemorialTheme={ isStickerTypeMemorial }
        >
            <div className={styles.deleteModelContainer}>
                {t('deleteMessage')}
                <UQButton label={t('deleteButton')}
                          containerClass={styles.attachFloatButton}
                          theme={'danger'}
                          onPress={() => {
                              dispatch(deleteStickerItem(stickerItem))
                                  .then(onBack);
                              setConfirmStickerDelete(false);
                          }}/>
            </div>
        </ConfirmModal>
        <Div100vh className={ isStickerTypeMemorial ? styles.scrollView_memorial : styles.scrollView } style={{minHeight: '100rvh'}}>
            <div className={styles.page}>
                {
                    showState.formErrors.server && (
                        <div className={styles.modal}>
                            <div className={styles.formError}>
                                <Icon name="InputError" width="15px" height="15px"/>
                                <div className={styles.formErrorText}>{t('serverError')}</div>
                            </div>
                        </div>
                    )}
                <LayoutComponentsLoaderProcessing isMemorialTheme={ isStickerTypeMemorial } opacity={1} show={false}/>
                {
                    stickerItem
                    && renderStickerShow()}
                {
                    !showState.isStickerConfigured
                    && !stickerItem && (
                        <div className={styles.notConfiguredSplash}>
                            <span className={styles.notConfiguredText}>{t('stickerNotConfigured')}</span>
                        </div>
                    )}
            </div>
        </Div100vh>
    </Fragment>
}



// WEBPACK FOOTER //
// ./src/app/modules/stickers/ui/screens/sticker-item-show/index.tsx